// extracted by mini-css-extract-plugin
export default {"container":"Banner_container__8PsmH","title":"Banner_title__yf9ra","description":"Banner_description__mlUFP"};